import styled from 'styled-components';
import {
  InputNumber,
} from 'antd';
import {
  COLOR_CV_5,
  COLOR_NEUTRAL_5,
} from 'constants/colors';

export const StyledAntdInputNumber = styled(InputNumber)`
  &:hover {
    border-color: ${COLOR_CV_5};

    &.ant-input-number-disabled {
      border-color: ${COLOR_NEUTRAL_5};
    }
  }

  &:focus {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }

  &.ant-input-number-focused {
    border-color: ${COLOR_CV_5};
    box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
  }
`;
